import React, { useEffect, useState } from 'react';
import ReplayCard from '../Card/ReplayCard';
import { useTranslation } from 'react-i18next';
import useApi from '../../hooks/useApi';
import { useInView } from 'react-intersection-observer';
import { useNavigate } from 'react-router-dom';

const VideoReplayWrapper = () => {
  const { t } = useTranslation();
  const [playlist, setPlaylist] = useState([]);
  const [nextKey, setNextKey] = useState(0);

  const [ref, inView] = useInView();
  const api = useApi();
  const navigate = useNavigate();

  const fetchPlaylist = async () => {
    let key_param = '';
    if (nextKey !== null && nextKey !== 0) {
      key_param = `?next_key=${nextKey}`;
    }

    try {
      const response = await api.get(`mubeat_live/clip/playlist?${key_param}`);
      const newPlaylist = response.data.clips;

      if (newPlaylist && newPlaylist.length > 0) {
        const combinedPlaylist = [...newPlaylist, ...playlist];
        setPlaylist(combinedPlaylist);
        const newNextKey = response?.data?.next_key;
        if (nextKey !== null) {
          setNextKey(newNextKey);
        }
      }
    } catch (error) {
      if (error.code === 'ERR_NETWORK' || error.code === 'ERR_BAD_RESPONSE') {
        navigate('/error');
      } else {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    fetchPlaylist();
  }, []);

  useEffect(() => {
    // inView: 스크롤이 하단에 닿았을 때 true
    if (inView) {
      if (nextKey) fetchPlaylist();
    }
  }, [inView]);

  return (
    <div className={'ml-video-replay-wrapper'}>
      <div className='ml-video-replay-title-wrapper'>
        <h3 className={'ml-video-replay-title'}>{t('up_next')}</h3>
      </div>
      <div className='ml-video-replay-content-wrapper component-custom-scroll'>
        <ul className={'ml-video-replay-content-group'}>
          {playlist?.map((item) => {
            return (
              <li key={item.clipmetaid} className={'ml-video-replay-content-list'}>
                <ReplayCard item={item} />
              </li>
            );
          })}
        </ul>
      </div>
      <span ref={ref} style={{ opacity: 0 }} />
    </div>
  );
};

export default VideoReplayWrapper;
